import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  Grid,
  Card,
  Typography,
  Box,
  CircularProgress,
  Breadcrumbs,
  Rating,
  Tooltip
} from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { BLACK, GRAY_LIGHT, PRIMARY, SECONDARY, WHITE } from "../styles/color";
import ageImage from "../Images/Red-flag.png";
import vector from "../Images/Vector.png";
import startIcon from "../Images/starticon.png";
import Combo from "../Landing/Components/Combo";
import ProductCard from "../components/ProuctCard";
import offerImage from "../Images/%off.png";
import "./CSS/productDetail.css";
import ScrollToTop from "../components/MovotoTop";
import { fetchEvents } from "../Features/Events/EventSlice";
import bgImage from "../Images/offer-bg.png";
import API_URL from "../ServiceModule/Service";
import {
  addToCart,
  removeFromCart,
  removeItemFromCart,
} from "../Features/services/cartSlice";
import {
  useGetAPIWithoutTokenQuery,
  usePostAddToCartWithTokenMutation,
  useRemoveFromCartWithTokenMutation,
} from "../Api/api";
import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  CATEGORIES_PARENTDATA,
} from "../Api/apiConstant";
import GlobalButton from "../components/GlobalButton";
import AddShoppingCartIcon from "../Images/cart-icon.png";
import debounce from "lodash.debounce";
import { toast, ToastContainer } from "react-toastify";
import { useThemeColors } from "../Context/Theme";
import { getLoggedIn, getToken, getUserId } from "../LoginModule/LoginUtility";
import { getInputValueAsString } from "@mui/base/unstable_useNumberInput/useNumberInput";


const ProductDetail = () => {
  const {
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading
  } = useThemeColors()
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const eventName = sessionStorage.getItem("eventName");
  const event_id = sessionStorage.getItem('event_id')

  const { productId } = useParams();

  const [product, setProduct] = useState(null);

  const [selectedSku, setSelectedSku] = useState(null);
  const [loading, setLoading] = useState(false);

  const [AddToCart] = usePostAddToCartWithTokenMutation();
  const [RemoveFromCart] = useRemoveFromCartWithTokenMutation();
  const [Removecart] = useRemoveFromCartWithTokenMutation();
  const userId = getUserId()
  const token = getToken()
  const cartId = sessionStorage.getItem("cartId");
  const eventname = sessionStorage.getItem("event_name");
  const offerData = useSelector((state) => state.offer.value);
  const isLoggedIn = getLoggedIn()
  const itemsAddedInCart = useSelector((state) => state.cart.items);
  const events = useSelector((state) => state.events.events);
  const {
    data: categoriesParentdata,
    isError,
    isLoading,
    isSuccess,
  } = useGetAPIWithoutTokenQuery(
    `${CATEGORIES_PARENTDATA}?category_id=${product?.categories[0]?.category_id}`, { skip: !product?.categories[0]?.category_id }
  );
  const [quantity, setQuantity] = useState(0)
  const [blankQuantitySku, setBlankQuantitySku] = useState([])
  const [selectedSkuQuantity, setSelctedSkuQuantity] = useState([])

  const productApiUrl = useMemo(
    () => `${API_URL}/api/product/getProductById?product_id=${productId}&event_id=${event_id}`,
    [productId, event_id]
  );

  const getProductById = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(productApiUrl);

      if (response?.data?.length > 0) {
        const productData = response?.data[0];
        setProduct(productData);
        const categoryId = productData?.categories?.[0]?.category_id;

        if (categoryId) {
          handleRelatedProduct(categoryId);
        }
        setSelectedSku(productData?.skus?.filter(i => i.sku_status === 1)?.[0]);
      } else {
        console.error("No product data found for the given product_id.");
      }
    } catch (error) {
      console.error("Error fetching product by ID:", error);
    } finally {
      setLoading(false);
    }
  }, [productApiUrl]);

  // Fetch data only when productId changes
  useEffect(() => {
    if (productId) {
      getProductById();
    }
  }, [productId, getProductById]);

  const cartItem = itemsAddedInCart.find((item) => {
    return (
      item?.product_id === product?.product_id &&
      item?.sku_id === selectedSku?.sku_id
    );
  });

  useEffect(() => {
    if (cartItem?.quantity) {
      setQuantity(cartItem?.quantity)
    }
  }, [cartItem?.quantity])


  useEffect(() => {
    dispatch(fetchEvents());
  }, [dispatch]);

  const latestEvent = events &&
    events?.find((n) => n?.event_id == sessionStorage?.getItem("event_id"));


  const [selectedImage, setSelectedImage] = useState(null);
  const rating = 4;

  const [selectedProduct, setSelectedProduct] = useState({});

  useEffect(() => {
    if (product?.skus && product.skus.length > 0) {
      setSelectedProduct(product.skus[0]);
    }
  }, [product]);

  const [productData, setProductData] = useState([]);
  const [relatedProduct, setRelatedProduct] = useState(null);
  const productFilterData = productData.filter((product) => product.product_id !== parseInt(productId))
  const eventId = sessionStorage.getItem("event_id");
  const handleRelatedProduct = async (categoryId) => {
    if (eventId !== null) {
      try {
        const response = await axios.get(
          `${API_URL}/api/product/getEventById?event_id=${eventId}&category_id=${categoryId}`
        );

        setRelatedProduct(response?.data?.data[0]?.product_id);
        setProductData(response?.data?.data);
      } catch (err) {
        console.error("Error fetching products:", err);
      }
    }
  };

  const handleUnitSelect = (product, skuId) => {
    try {
      const selectedSku = product?.skus.find((sku) => sku?.sku_id === skuId);
      if (selectedSku) {
        setSelectedSku(selectedSku);
        setQuantity(itemsAddedInCart.find(i => i.sku_id === skuId) ? itemsAddedInCart.find(i => i.sku_id === skuId)?.quantity : 0)
      }
    } catch (error) {

    }
  };

  const handleAddToCart = async (product, value) => {
    const selectedSkuData = selectedSku || product?.skus?.filter(i => i.sku_status === 1)[0];
    {
      const currentDate = new Date();
      const preorderStartDate = new Date(
        sessionStorage.getItem("preorderStartDate")
      );
      const preorderEndDate = new Date(
        sessionStorage.getItem("preorderEndDate")
      );
      preorderStartDate.setUTCHours(0, 0, 0, 0);
      preorderEndDate.setUTCHours(23, 59, 59, 999);
      if (currentDate < preorderStartDate) {
        toast.error("Pre-order has not started yet.");
        return;
      } else if (currentDate > preorderEndDate) {
        toast.error(
          "The pre-order period has expired. You can't place an order."
        );
        return;
      }
    }
    if (value === "") {
      setQuantity("")
      debouncedRemoveFromCart(product, "")
      return;
    }
    if (value === 0) {
      setQuantity(0)
      debouncedRemoveFromCart(product, 0)
      return;
    }
    const newCartItem = {
      product_id: product.product_id,
      sku_id: selectedSkuData?.sku_id,
      quantity: value && value > 0 ? value : selectedSkuData?.quantity ? selectedSkuData.quantity + 1 : 1,
      price: selectedSkuData?.discount_price || selectedSkuData?.regular_price,
    };

    const existingCartItem = itemsAddedInCart?.find(
      (item) =>
        item.product_id === newCartItem.product_id &&
        item.sku_id === newCartItem.sku_id
    );

    if (existingCartItem) {
      newCartItem.quantity = value && value > 0 ? value : existingCartItem.quantity + 1;
    }

    if (!isLoggedIn) {
      return navigate(`/events/${eventName}/login`);
    }
    setQuantity(newCartItem.quantity)

    // dispatch(addToCart({ ...product, quantity: newCartItem.quantity }));

    try {
      const { data } = await AddToCart({
        url: ADD_TO_CART,
        formData: {
          user_id: userId,
          items: [newCartItem],
          event_id: eventId,
        },
        token,
      });

      if (data.message === "Cart and CartItems processed successfully") {
        sessionStorage.setItem("cartId", data.cart_id);
      }
    } catch (error) {
      console.error("Add to cart error:", error);
    }
  };

  const handleRemoveFromCart = async (product, value) => {
    const isSelectedSkuEmpty =
      !selectedSku || Object.keys(selectedSku).length === 0;

    const selectedSkuId = isSelectedSkuEmpty
      ? product?.skus?.filter(i => i.sku_status === 1)?.[0]?.sku_id
      : selectedSku?.sku_id;

    const selectedProduct = isSelectedSkuEmpty
      ? { ...product, skus: [product?.skus[0]?.skus?.filter(i => i.sku_status === 1)?.[0]] }
      : { ...product, skus: [selectedSku] };

    const existingCartItem = itemsAddedInCart?.find((item) => {
      return (
        item?.product_id === selectedProduct?.product_id &&
        item?.sku_id === selectedSkuId
      );
    });

    if (!existingCartItem) {
      console.warn("Product not found in cart.");
      return;
    }
    if (value === undefined || value === null) {
      setQuantity(null)
    }
    const newQuantity = value === "" || value === 0 ? 0 : existingCartItem.quantity - 1;
    const newCartItem = {
      product_id: existingCartItem.product_id,
      sku_id: existingCartItem.sku_id,
      bundle_id: existingCartItem.bundle_id,
      quantity: Math.max(newQuantity, 0),
      price:
        existingCartItem?.product_details?.skus[0]?.discount_price ||
        existingCartItem?.product_details?.skus[0]?.regular_price,
    };

    try {
      setQuantity(newQuantity)
      if (newQuantity > 0) {
        dispatch(removeFromCart({ ...product, quantity: newQuantity }));

        await Removecart({
          url: ADD_TO_CART,
          formData: {
            user_id: userId,
            items: [newCartItem],
            event_id: eventId,
            callFrom: 'Remove'
          },
          token,
        });
      } else {
        dispatch(removeItemFromCart({ itemId: existingCartItem.product_id }));

        await RemoveFromCart({
          url: REMOVE_FROM_CART,
          formData: {
            cart_id: cartId,
            product_id: existingCartItem.product_id,
            sku_id: existingCartItem.sku_id,
          },
          token,
        });
      }
    } catch (error) {
      console.error("Error while removing from cart:", error);
    }
  };

  const debouncedAddToCart = debounce(handleAddToCart, 300);
  const debouncedRemoveFromCart = debounce(handleRemoveFromCart, 300);

  const handleProductUnitSelect = (product, skuId) => {
    try {
      const selectedSku = product?.skus.find((sku) => sku?.sku_id === skuId);
      if (selectedSku) {
        setSelectedSku((prevSelectedSku) => ({
          ...prevSelectedSku,
          [product.product_id]: selectedSku,
        }));
      }
    } catch (error) {

    }
  };

  const handleChangeQuantity = async (value, product) => {
    const selectedSkuData = selectedSku[product.product_id] || product?.skus?.filter(i => i.sku_status === 1)?.[0];
    if (value === "") {
      setSelctedSkuQuantity(selectedSkuQuantity.filter(n => n.skuId !== selectedSkuData.sku_id))
      setBlankQuantitySku(prev => [...prev, selectedSkuData.sku_id])
      handleProductRemoveFromCart(product, 0)
      return;
    }
    if (value === 0) {
      handleProductRemoveFromCart(product, 0)
    }
    {
      const currentDate = new Date();
      const preorderStartDate = new Date(
        sessionStorage.getItem("preorderStartDate")
      );
      const preorderEndDate = new Date(
        sessionStorage.getItem("preorderEndDate")
      );
      preorderStartDate.setUTCHours(0, 0, 0, 0);
      preorderEndDate.setUTCHours(23, 59, 59, 999);
      if (currentDate < preorderStartDate) {
        toast.error("Pre-order has not started yet.");
        return;
      } else if (currentDate > preorderEndDate) {
        toast.error(
          "The pre-order period has expired. You can't place an order."
        );
        return;
      }
    }
    // Create the new cart item with the desired structure
    setBlankQuantitySku(blankQuantitySku.filter(i => i !== selectedSkuData.sku_id))
    setSelctedSkuQuantity(prev => {
      // Remove any previous entries with the same skuId
      const filtered = prev.filter(item => item.skuId !== selectedSkuData.sku_id);
      // Add the new one at the end
      return [...filtered, { skuId: selectedSkuData.sku_id, quantity: value }];
    });
    const newCartItem = {
      product_id: product.product_id,
      sku_id: selectedSkuData?.sku_id,
      quantity: value ? value : selectedSkuData?.quantity ? selectedSkuData.quantity + 1 : 1,
      price: selectedSkuData?.discount_price || selectedSkuData?.regular_price,
    };

    const existingCartItem = itemsAddedInCart?.find(
      (item) =>
        item.product_id === newCartItem.product_id &&
        item.sku_id === newCartItem.sku_id
    );

    if (existingCartItem) {
      newCartItem.quantity = value;
    }

    if (!isLoggedIn) {
      return navigate(`/events/${eventName}/login`);
    }

    // dispatch(addToCart({ ...product, quantity: newCartItem.quantity }));

    try {
      const { data } = await AddToCart({
        url: ADD_TO_CART,
        formData: {
          user_id: userId,
          items: [newCartItem],
          event_id: eventId,
        },
        token,
      });

      if (data.message === "Cart and CartItems processed successfully") {
        sessionStorage.setItem("cartId", data.cart_id);
      }
    } catch (error) {
      console.error("Add to cart error:", error);
    }
  };


  const handleProductAddToCart = async (product) => {
    {
      const currentDate = new Date();
      const preorderStartDate = new Date(
        sessionStorage.getItem("preorderStartDate")
      );
      const preorderEndDate = new Date(
        sessionStorage.getItem("preorderEndDate")
      );
      preorderStartDate.setUTCHours(0, 0, 0, 0);
      preorderEndDate.setUTCHours(23, 59, 59, 999);
      if (currentDate < preorderStartDate) {
        toast.error("Pre-order has not started yet.");
        return;
      } else if (currentDate > preorderEndDate) {
        toast.error(
          "The pre-order period has expired. You can't place an order."
        );
        return;
      }
    }
    const selectedSkuData = selectedSku[product.product_id] || product?.skus?.filter(i => i.sku_status === 1)?.[0];
    setSelctedSkuQuantity(selectedSkuQuantity.filter(n => n.skuId !== selectedSkuData.sku_id))
    setBlankQuantitySku(blankQuantitySku.filter(i => i !== selectedSkuData.sku_id))

    const newCartItem = {
      product_id: product.product_id,
      sku_id: selectedSkuData?.sku_id,
      quantity: selectedSkuData?.quantity ? selectedSkuData.quantity + 1 : 1,
      price: selectedSkuData?.discount_price || selectedSkuData?.regular_price,
    };

    const existingCartItem = itemsAddedInCart?.find(
      (item) =>
        item.product_id === newCartItem.product_id &&
        item.sku_id === newCartItem.sku_id
    );

    if (existingCartItem) {
      newCartItem.quantity = existingCartItem.quantity + 1;
    }

    if (!isLoggedIn) {
      return navigate(`/events/${eventName}/login`);
    }

    // dispatch(addToCart({ ...product, quantity: newCartItem.quantity }));

    try {
      const { data } = await AddToCart({
        url: ADD_TO_CART,
        formData: {
          user_id: userId,
          items: [newCartItem],
          event_id: eventId,
        },
        token,
      });

      if (data.message === "Cart and CartItems processed successfully") {
        sessionStorage.setItem("cartId", data.cart_id);
      }
    } catch (error) {
      console.error("Add to cart error:", error);
    }
  };

  const handleProductRemoveFromCart = async (product, value) => {
    const selectedSkuData = selectedSku[product.product_id] ? selectedSku[product.product_id] : product?.skus?.filter(i => i.sku_status === 1)?.[0];
    if (value !== 0) {
      setSelctedSkuQuantity(selectedSkuQuantity.filter(n => n.skuId !== selectedSkuData.sku_id))
      setBlankQuantitySku(blankQuantitySku.filter(i => i !== selectedSkuData.sku_id))
    }
    const existingCartItem = itemsAddedInCart?.find((item) => {

      return (
        item.product_id === product?.product_id &&
        item.sku_id === selectedSkuData?.sku_id
      );
    });

    if (!existingCartItem) {
      console.warn("Product not found in cart.");
      return;
    }

    const newQuantity = value === 0 ? value : existingCartItem.quantity - 1
    const newCartItem = {
      product_id: existingCartItem.product_id,
      sku_id: existingCartItem.sku_id,
      quantity: Math.max(newQuantity, 0),
      price:
        existingCartItem?.product_details?.skus[0]?.discount_price ||
        existingCartItem?.product_details?.skus[0]?.regular_price,
    };

    try {
      if (newQuantity > 0) {
        dispatch(removeFromCart({ ...product, quantity: newQuantity }));

        await Removecart({
          url: ADD_TO_CART,
          formData: {
            user_id: userId,
            items: [newCartItem],
            event_id: eventId,
          },
          token,
        });
      } else {
        dispatch(removeItemFromCart({ itemId: existingCartItem.product_id }));

        await RemoveFromCart({
          url: REMOVE_FROM_CART,
          formData: {
            cart_id: cartId,
            product_id: existingCartItem.product_id,
            sku_id: existingCartItem.sku_id,
          },
          token,
        });
      }
    } catch (error) {
      console.error("Error while removing from cart:", error);
    }
  };

  const handleCategoryClick = (categoryId, categoryName) => {

    navigate(`/events/${eventName}/shop`, {
      state: {
        category: categoryId,
        categoryName: categoryName
      }
    });
  };

  // const handleCategoryClick = (categoryId) => {
  //   navigate(`/events/${eventName}/shop`, { state: { category: categoryId } });
  // };

  function handleShop() {
    navigate(`/events/${eventName}/shop`, { state: { category: "all" } });
  }

  const breadcrumbs = [
    <Link
      to={`/events/${eventName}`}
      className="text-decoration-none font-size text-secondary"
      style={{ fontSize: "17px" }}
      underline="hover"
      key="1"
      color="inherit"
      href="/"
    >
      {eventname}
    </Link>,
    <Typography key="3" color="text.primary" style={{ fontSize: "17px", cursor: "pointer" }}
      onClick={() => handleShop()}
    >
      Shop
    </Typography>,
  ];

  // Add parent categories to breadcrumbs
  if (categoriesParentdata && categoriesParentdata.length > 0) {
    categoriesParentdata.forEach((category, index) => {
      breadcrumbs.push(
        <Typography key={index + 4} color="text.primary" style={{ fontSize: "17px", cursor: "pointer" }}
          onClick={() => handleCategoryClick(category.category_id, category.category_name)}
        >
          {category.category_name}
        </Typography>
      );
    });
  }

  // Add product name to breadcrumbs
  breadcrumbs.push(
    <Typography key="3" color="text.primary" style={{ fontSize: "17px" }}>
      {product?.product_name}
    </Typography>
  );

  // const breadcrumbs = [
  //   <Link
  //     to={`/events/${eventName}`}
  //     className="text-decoration-none font-size text-secondary"
  //     style={{ fontSize: "17px" }}
  //     underline="hover"
  //     key="1"
  //     color="inherit"
  //     href="/"
  //   >
  //     {eventname}
  //   </Link>,
  //   <Typography key="3" color="text.primary" style={{ fontSize: "17px", cursor: "pointer" }}
  //     onClick={() => handleShop()}
  //   >
  //     Shop
  //   </Typography>,
  //   <Typography key="3" color="text.primary" style={{ fontSize: "17px", cursor: "pointer" }}
  //   onClick={() => handleCategoryClick(product?.categories[0]?.category_id, product?.categories[0]?.category_name)}
  //     // onClick={() => handleCategoryClick(product?.categories[0]?.category_id)}
  //   >
  //     {product?.categories[0]?.category_name}
  //   </Typography>,
  //   <Typography key="3" color="text.primary" style={{ fontSize: "17px" }}>
  //     {product?.product_name}
  //   </Typography>,
  // ];

  return (
    <>
      <ToastContainer autoClose={2000} />

      <Navbar className="sticky-navbar" />

      <ScrollToTop />
      {loading ? (
        <div
          style={{
            height: "100vh",
            width: "100vw",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress sx={{ color: "red" }} />
        </div>
      ) : (
        <div className="overflow-hidden" style={{ marginTop: "15vh" }}>
          <div className="px-5 py-4">
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              {breadcrumbs}
            </Breadcrumbs>
          </div>
          <Grid container spacing={4} className="mb-5">
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Card
                style={{

                  borderRadius: "26px",
                  border: "1px solid #E9E9E9",
                  width: "85%",
                  height: "50vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <img
                  src={
                    selectedImage ||
                    (product?.productImg[0]?.product_img?.includes(
                      "https://festival-outfitter-dev.s3.amazonaws.com/images/"
                    )
                      ? product?.productImg[0]?.product_img
                      : product?.productImg[0]?.product_img_path)
                  }

                  component="img"
                  alt={product?.product_name}
                  image={selectedImage}
                  style={{
                    objectFit: "cover",
                    maxWidth: "100%",
                    maxHeight: "100%",
                  }}
                />

                {product?.categories[0]?.age_validation !== "No" && (
                  <div
                    style={{
                      position: "absolute",
                      top: "0px",
                      right: "40px",
                      width: "10%",
                      height: "auto",
                      zIndex: 1,
                      backgroundImage: `url(${ageImage})`,
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "0.8rem",
                      padding: "0.5rem",
                      paddingBottom: "1em",
                    }}
                  >
                    {product?.categories[0]?.age_validation}+<br />
                    only
                  </div>
                )}
              </Card>

              {/* Thumbnail Images */}
              <Grid
                container
                spacing={2}
                style={{ margin: "10px", justifyContent: "center" }}
              >
                {product?.productImg.map((img, index) => (
                  <Grid item xs={4} sm={3} md={2} key={img.product_img_id}>
                    <Card
                      style={{
                        cursor: "pointer",
                        border: "1px solid #E9E9E9",

                        borderRadius: "12px",
                        width: "104px",
                        height: "98px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onClick={() =>
                        setSelectedImage(
                          img?.product_img.includes(
                            "https://festival-outfitter-dev.s3.amazonaws.com/images/"
                          )
                            ? img?.product_img
                            : img?.product_img_path
                        )
                      }

                    >
                      <img
                        src={
                          img?.product_img.includes(
                            "https://festival-outfitter-dev.s3.amazonaws.com/images/"
                          )
                            ? img?.product_img
                            : img?.product_img_path
                        }

                        component="img"
                        alt={`Thumbnail ${index + 1}`}
                        style={{
                          objectFit: "cover",
                          maxWidth: "100%",
                          maxHeight: "70%",
                        }}
                      />
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item xs={12} md={5} className="mt-3">
              <div
                className="pb-3"
                style={{ borderBottom: "1px solid #E3E3E3" }}
              >
                <p
                  style={{
                    fontSize: fontSize || "14px",
                    fontWeight: fontWeight || "500",
                    color: PRIMARY,
                    margin: "4px",
                    fontFamily,
                    cursor: 'pointer'
                  }}
                  onClick={() => handleCategoryClick(product?.categories[0]?.category_id)}
                >
                  {product?.categories[0]?.category_name}
                </p>
                <p
                  style={{
                    fontSize: fontSizeHeading || "28px",
                    fontWeight: fontWeightHeading || "600",
                    margin: "4px 4px",
                    fontFamily: fontFamilyHeading
                  }}
                >
                  {product?.product_name}
                </p>
              </div>
              <div>
                <p
                  className="my-3"
                  style={{ fontSize: "12px", fontWeight: "500", margin: 0, fontFamily }}
                >
                  Select Unit
                </p>
                <Grid container spacing={2}>
                  {product?.skus?.filter(i => i.sku_status === 1)?.map((sku) => {
                    return (
                      <Tooltip
                        key={sku?.sku_id}
                        title={sku?.unit}
                        arrow
                        placement="top"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#333",
                              color: "#fff",
                              fontSize: "12px",
                              borderRadius: "4px",
                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            },
                          },
                          arrow: {
                            sx: {
                              color: "#333",
                            },
                          },
                        }}>
                        <Grid item key={sku?.sku_id} xs={4} sm={6} md={2}>

                          <Card
                            style={{
                              minwidth: "100px",
                              minHeight: "70px",
                              backgroundColor:
                                selectedSku?.sku_id === sku?.sku_id
                                  ? SECONDARY
                                  : "#FFFFFF",
                              border: `1px solid ${selectedSku?.sku_id === sku?.sku_id
                                ? "#FFCBCC"
                                : "#888888"
                                }`,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                              borderRadius: "8px",
                              padding: "8px",
                              boxSizing: "border-box",
                              textAlign: "center",
                            }}
                            onClick={() => handleUnitSelect(product, sku?.sku_id)}
                          >
                            <div
                              style={{
                                fontSize: "12px",
                                fontWeight: "500",

                                marginBottom: "4px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "100%",
                                fontFamily
                              }}
                            >
                              {sku.unit},<br />{sku?.secondaryunit}
                            </div>
                            <div style={{
                              fontSize: "14px", fontWeight: "600", wordBreak: "break-word",
                              textAlign: "center",
                              fontFamily
                            }}>

                            </div>
                          </Card>
                        </Grid>
                      </Tooltip>
                    );
                  })}
                </Grid>

                {selectedProduct && (
                  <div style={{ marginTop: "20px" }}>
                    <div style={{ fontSize: fontSizeHeading || "32px", fontWeight: fontWeightHeading || "700", fontFamily: fontFamilyHeading }}>
                      $
                      {parseFloat((selectedSku?.discount_price > 0 || selectedSku?.discount_amount > 0)
                        ? selectedSku?.discount_price
                        : selectedSku?.regular_price)?.toFixed(2)}
                      {/* {selectedProduct.discount_price} */}
                      {(selectedSku?.discount_price > 0 || selectedSku?.discount_amount > 0)
                        && (parseFloat(selectedSku?.discount_price)?.toFixed(2) != parseFloat(selectedSku?.regular_price)?.toFixed(2))
                        && (
                          <span
                            style={{
                              fontSize: fontSizeHeading || "19px",
                              fontWeight: fontWeightHeading || "500",
                              textDecoration: "line-through",
                              marginLeft: "8px",
                              fontFamily: fontFamilyHeading
                            }}
                          >
                            {parseFloat(selectedSku?.regular_price)?.toFixed(2)}
                          </span>
                        )}
                      {(selectedSku?.discount_price > 0 || selectedSku?.discount_amount > 0)
                        && (parseFloat(selectedSku?.discount_price)?.toFixed(2) != parseFloat(selectedSku?.regular_price)?.toFixed(2))
                        && (
                          <span
                            className="px-2 py-1"
                            style={{
                              fontSize: fontSizeHeading || "14px",
                              fontWeight: fontWeightHeading || "500",
                              color: PRIMARY,
                              marginLeft: "8px",
                              backgroundColor: SECONDARY,
                              borderRadius: "30px",
                              fontFamily: fontFamilyHeading
                            }}
                          >
                            {
                              parseFloat(((parseFloat(selectedSku?.regular_price) -
                                parseFloat(selectedSku?.discount_price)) /
                                parseFloat(selectedSku?.regular_price)) *
                                100).toFixed(2)
                            }{" "}
                            % off
                          </span>
                        )}
                    </div>
                  </div>
                )}
              </div>
              {product?.categories[0]?.age_validation === "21" ? (
                <div>
                  <div className="mt-3">
                    <img
                      src={vector}
                      style={{
                        marginBottom: "4px",
                        width: "3%",
                        height: "3%",
                        marginRight: "2%",
                      }}
                    />
                    <span className="requirements-title" style={{ fontFamily: fontFamilyHeading }}>
                      {" "}
                      Some Requirements
                    </span>
                  </div>
                  <div className="requirements-text" style={{ fontFamily }}>
                    {" "}
                    Government Issued ID Required for Purchase
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    fontSize: fontSizeHeading || "16px",
                    fontWeight: fontWeightHeading || "400",
                    color: "#555557",
                    width: "480px",
                    maxHeight: "min-content",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    fontFamily: fontFamilyHeading
                  }}
                >
                  {product?.product_description}
                </div>
              )}

              {(quantity > 0 || quantity === "") && quantity !== null && quantity !== undefined ? (
                <div className="mt-5 mb-3" style={styles.container}>
                  <button
                    style={styles.button}
                    onClick={() => debouncedRemoveFromCart(product)}
                  >
                    -
                  </button>
                  <input
                    type="number"
                    step="1"
                    min="0"
                    max="9999"
                    value={quantity ?? ""}
                    style={{ ...styles.input, fontFamily }}
                    onChange={(e) => {
                      const val = e.target.value;

                      if (val === "") {
                        debouncedAddToCart(product, "");
                        return;
                      }

                      const value = parseInt(val, 10);

                      if (!isNaN(value) && value >= 0 && value <= 9999) {
                        debouncedAddToCart(product, value);
                      }
                    }}
                    onFocus={(e) => e.target.select()}
                    onKeyDown={(e) => {
                      if (e.key === '.' || e.key === ',' || e.key === 'e') {
                        e.preventDefault();
                      }
                    }}
                  />
                  <button
                    style={styles.button}
                    onClick={() => debouncedAddToCart(product)}
                  >
                    +
                  </button>
                </div>
              ) : (
                <div className="mt-5 mb-3">
                  <GlobalButton
                    text={"Add to Cart"}
                    startIcon={AddShoppingCartIcon}
                    size="small"
                    height={"4.5vh"}

                    onClick={() => debouncedAddToCart(product)}
                    border={"0.96px solid #379246"}
                  />
                </div>
              )}
            </Grid>
          </Grid>

          <Grid
            container
            spacing={4}
            style={{ paddingLeft: "5%", paddingRight: "5%" }}
          >
            <Grid item xs={12} sm={7} md={7} style={{ paddingRight: "2em" }}>
              <Typography
                variant="h5"
                component="p"
                style={{
                  fontWeight: fontWeightHeading || "600",
                  borderBottom: "2px solid red",
                  width: "fit-content",
                  marginBottom: "16px",
                  fontFamily: fontFamilyHeading,
                  fontSize: fontSizeHeading
                }}
              >
                Description
              </Typography>
              <Typography
                variant="body1"
                component="p"
                style={{ fontWeight: fontWeight || "400", fontSize, fontFamily, color: "#555557" }}
              >
                {product?.product_description}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={5}
              md={5}
              style={{
                position: "relative",
                backgroundImage: `url(${latestEvent?.event_img_path || bgImage
                  })`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                padding: "4% 5%",
                borderRadius: "17px",
                color: "#fff",
                textAlign: "center",
                justifyContent: "center",
                display: "flex",
                height: "100%",
                minHeight: "250px",
                flexDirection: "column",
                marginTop: "2em",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  borderRadius: "17px",
                  zIndex: 1,
                }}
              />

              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                style={{
                  zIndex: 2,
                  marginTop: "auto",
                  marginBottom: "auto",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="h4"
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.8rem",
                    marginBottom: "8px",
                    fontFamily: fontFamilyHeading
                  }}
                >
                  Order That
                </Typography>

                <Typography
                  variant="h5"
                  style={{
                    marginTop: "0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={latestEvent?.event_logo_path || bgImage}
                    alt="NASCAR Logo"
                    style={{
                      height: "24px",
                      maxWidth: "100%",
                    }}
                  />
                </Typography>

                <div
                  style={{
                    marginTop: "12px",
                    fontSize: "20px",
                    fontWeight: "700",
                    borderTop: "6px solid #FE3B3E",
                    paddingTop: "12px",
                    textAlign: "center",
                    fontFamily: fontFamilyHeading
                  }}
                >
                  <p className="logo-line-text" style={{ margin: 0, fontFamily: fontFamilyHeading }}>
                    ORDER THAT caters {latestEvent?.event_name} crowd with food
                    and drinks.
                  </p>
                </div>
              </Grid>
            </Grid>
          </Grid>

          {/* <Combo /> */}
          <div style={{ paddingTop: "2%" }}>
            <Combo eventName={eventName} />
          </div>


          {productFilterData?.length > 0 && (

            <div
              style={{
                margin: "20px 0",
                maxWidth: "1450px",
                marginLeft: "2.7em",
                display: "flex",
              }}

            >
              <p
                style={{
                  fontSize: fontSizeHeading || "25px",
                  fontWeight: fontWeightHeading || "700",
                  marginBottom: "10px",
                  fontFamily: fontFamilyHeading
                }}
              >
                Related Products
              </p>
            </div>
          )}
          {productFilterData && productFilterData.length > 0 ?
            <div
              style={{
                margin: "20px 0",
                // padding: "29px",
                maxWidth: "1450px",
                marginLeft: "2.7em",
                display: "flex",
                flexDirection: "row",
              }}

            >

              <Grid container spacing={3} justifyContent="start">
                {productFilterData.map((product, index) => {
                  return (
                    <Grid
                      item
                      xs={12}
                      md={2.8}
                      key={product.product_id || `product-${index}`}
                      style={{ position: "relative" }}
                    >
                      <ProductCard
                        offer={product?.offer}
                        ageRestriction={
                          product?.categories[0]?.age_validation === "21"
                        }
                        productName={product?.product_name}
                        productType={product?.categories[0]?.category_name}
                        sku={product?.skus}
                        price={
                          selectedSku[product.product_id]?.regular_price ||
                          product?.skus[0]?.regular_price || 0
                        }
                        discount={
                          selectedSku[product.product_id]?.discount_price ||
                          product?.skus[0]?.discount_price || 0
                        }
                        offerDiscount={
                          selectedSku[product.product_id]?.discount_amount ||
                          product?.skus[0]?.discount_amount || 0
                        }
                        product={product}
                        productId={product?.product_id}
                        image={product?.productImg?.[0]?.product_img}
                        rating={product?.rating || 4}
                        buttonText="ADD"
                        onClick={() => handleProductAddToCart(product)}
                        offerImage={offerImage}
                        addQuantity={() => handleProductAddToCart(product)}
                        removeQuantity={() =>
                          handleProductRemoveFromCart(product)
                        }
                        onUnitSelect={(prod, skuID, selectedSkus) =>
                          handleProductUnitSelect(prod, skuID)
                        }
                        handleChangeQuantity={handleChangeQuantity}
                        blankQuantitySku={blankQuantitySku}
                        selectedSkuQuantity={selectedSkuQuantity}
                      />
                    </Grid>
                  )
                })}
              </Grid>
            </div>
            :
            <></>
          };

          <Footer />
        </div>
      )}
    </>
  );
};

const styles = {
  container: {
    borderRadius: "26px",
    border: "1px solid #D9D9D9",
    width: "100%",
    maxWidth: "150px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px 10px",
    boxSizing: "border-box",
  },
  button: {
    backgroundColor: "#f0f0f0",
    border: "none",
    borderRadius: "20px",
    width: "30px",
    height: "30px",
    cursor: "pointer",
    fontSize: "18px",
  },
  input: {
    width: "40px",
    textAlign: "center",
    border: "none",
    outline: "none",
    fontSize: "16px",
    backgroundColor: "transparent",
    margin: "0 5px",
  },
};

export default ProductDetail;
